import Vue from "vue";

const state = {
  loading: 0
};

// getters
const getters = {
  loading: () => {
    return !!state.loading;
  }
};

// actions
const actions = {};

// mutations
const mutations = {
  increment(state) {
    state.loading++;
  },
  decrement(state) {
    state.loading--;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
